export default __webpack_public_path__ + "static/media/love.4e24b9a9.svg";